<template>
  <van-uploader v-model="fileList" :deletable="deletable" :accept="accept" :preview-image="previewImage"
    :after-read="afterRead" :max-count="maxCount" :before-read="beforeRead" :multiple="multiple"
    :before-delete="beforeDelete" :max-size="maxSize" :preview-size="previewSize" @oversize="onOversize">
    <slot></slot>
  </van-uploader>
</template>
<script>
import { uploadImage } from '@/api/new_api'
import { Toast } from 'vant';
export default {
  name: 'KubuqiGameVantUploadImage',
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    // preview-size	预览图和上传区域的尺寸，默认单位为 px
    previewSize: {
      type: String,
      default: '100%'
    },
    maxCount: {
      type: Number,
      default: 1
    },
    multiple: {
      type: Boolean,
      default: false
    },
    previewImage: {
      type: Boolean,
      default: true
    },
    deletable: {
      type: Boolean,
      default: true
    },
    beforeDelete: {
      type: Function,
      default: () => { }
    },
    type: {
      //1:图片 2:视频 3 文件
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      fileList: []
    }
  },

  watch: {
    value: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal, 111)
        // 判断新值与旧值是否相等
        if (newVal == '') {
          this.fileList = []
        } else if (newVal != oldVal) {
          // 定义一个列表变量
          const list =
            // 如果新值为字符串类型
            typeof newVal == 'string'
              ? // 将字符串按逗号分隔，并将每个元素转换为对象形式（包含url属性）
              newVal.split(',').map((el) => ({ url: el, status: 'none' }))
              : // 如果新值为数组类型
              newVal.map((el) => ({ url: el }))
          // 将转换后的列表赋值给this.fileList
          this.fileList = list
          console.log(this.fileList, 222)
        }
      },
      immediate: true
    }
  },
  computed: {


    maxSize() {
      switch (Number(this.type)) {
        case 1: // 图片 50MB
          return 50 * 1024 * 1024
        case 2: // 视频 5g
          return 2 * 1024 * 1024 * 1024
        case 3: // 文档 50MB
          return 200 * 1024 * 1024
        default:
          return 50 * 1024 * 1024
      }
    }
  },
  mounted() { },

  methods: {
    beforeRead(file) {


      return true
    },
    async afterRead(file) {
      console.log(file, 'file')
      file.status = 'uploading'
      let res = await uploadImage({
        file: file.file,
        type: this.getType(file.file.type)
      })
      console.log(res, 'res')
      if (res.code == 1) {
        const obj = {
          url: res.data.uri,
          name: file.file.name
        }
        console.log(obj, 333)
        this.fileList = [obj]
        this.$emit('change', this.fileList)
        file.status = 'none'
      } else {
        file.status = 'failed'
        file.message = '上传失败'
      }
    },
    getType(type) {
      //     图片(image):
      // .jpg/.jpeg: 'image/jpeg'
      // .png: 'image/png'
      // .gif: 'image/gif'
      // .webp: 'image/webp'
      // .bmp: 'image/bmp'
      if (['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/webp', 'image/bmp'].includes(type)) {
        return 1
      } else if (['video/mp4', 'video/webm', 'video/ogg', 'video/quicktime', 'video/x-ms-wmv', 'video/x-msvideo'].includes(type)) {
        // 视频(video):
        // .mp4: 'video/mp4'
        // .webm: 'video/webm'
        // .ogg: 'video/ogg'
        // .mov: 'video/quicktime'
        // .wmv: 'video/x-ms-wmv'
        // .avi: 'video/x-msvideo'
        return 2
      } else if (['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'].includes(type)) {
        //         文档的 MIME 类型对应关系：
        // .doc: 'application/msword'
        // .docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        // .pdf: 'application/pdf'
        // .ppt: 'application/vnd.ms-powerpoint'
        // .pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        return 3
      } else {
        return 1
      }
    },
    onOversize() {
      const sizeMap = {
        1: '50MB',
        2: '2GB',
        3: '50MB'
      }
      Toast(`文件大小不能超过 ${sizeMap[this.type]}`)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-uploader {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .van-uploader__input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .upload-text {
    font-size: 12px;
    color: #2c8779;
  }
}

::v-deep .van-uploader__wrapper {
  height: 100% !important;
  width: 100% !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .van-uploader__preview {
    margin: 0 !important;
    height: 100%;
    width: 100%;
  }
}

.upload-icon {
  width: 29px;
}
</style>
